module.exports = __webpack_public_path__ + "img/bc.d0accf3a.png";